export enum HardwareProcessStatus {
    completed = 'completed',
    failed = 'failed',
    running = 'running',
    starting = 'starting',
    success = 'success',
    uploading = 'uploading',
}
